import { action, observable } from "mobx";
import NestStore from "~/stores/NestStore";
import UiMeet3dWsTokenRepository from "~/repository/UiMeet3d/UiMeet3dWsTokenRepository";

class UiMeet3dWsTokenStore extends NestStore {
  /**
   * @property {string|null}
   */
  @observable uiMeet3dWsToken = null;

  /**
   * @property {number|null}
   */
  tourId = null;

  uiMeet3dWsTokenRepository = null;

  constructor() {
    super();

    this.uiMeet3dWsTokenRepository = new UiMeet3dWsTokenRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getOne()]).finally(() => {
      this.isLoading = false;
    });
  }

  @action
  getOne() {
    return this.uiMeet3dWsTokenRepository.fetchOne(this.tourId).then(response => {
      this.uiMeet3dWsToken = response.data.uiMeet3dWsToken;
    });
  }
}

export default UiMeet3dWsTokenStore;
